import React, { useEffect, useState } from 'react';
import * as Api from '../../DescricaoEntregaService';

function DescricaoEntregaModal({ show, onClose, onSave, data }) {
  const [descricao, setDescricao] = useState('');
  const [id, setId] = useState(null);
  const [saving, setSaving] = useState(false);

  const vinculo = (() => {
    try { const v = localStorage.getItem('vinculo'); return v ? JSON.parse(v) : null; } catch(e) { return null; }
  })();

  useEffect(() => {
    if (show) {
      if (data) {
        setId(data.id);
        setDescricao(data.descricao || '');
      } else {
        setId(null);
        setDescricao('');
      }
    }
  }, [data, show]);

  const handleSave = async () => {
    if (!vinculo?.idEntidade) return;
    setSaving(true);
    try {
      const payload = { id, idEntidade: vinculo.idEntidade, descricao };
      const saved = id ? await Api.update(payload) : await Api.save(payload);
      if (onSave) onSave(saved);
      if (onClose) onClose();
    } catch (err) {
      console.error(err);
      if (onSave) onSave(null);
    } finally {
      setSaving(false);
    }
  };

  if (!show) return null;

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }} onClick={onClose}>
      <div className="modal-dialog modal-dialog-centered modal-lg" onClick={e => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-header text-white" style={{ background: 'linear-gradient(45deg, rgb(7, 29, 65) 0%, rgba(29, 100, 216, 1) 100%)', padding: '0.5rem 1rem' }}>
            <h6 className="modal-title mb-0">{id ? 'Editar Descrição' : 'Nova Descrição'}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose} disabled={saving} aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="mb-2">
              <label className="form-label">Descrição</label>
              <textarea className="form-control" rows={6} value={descricao} onChange={(e) => setDescricao(e.target.value)} />
            </div>
          </div>
          <div className="modal-footer py-2">
            <button className="btn btn-secondary me-2" onClick={onClose} disabled={saving}>Cancelar</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Salvando...' : 'Salvar'}</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DescricaoEntregaModal;
